export const TOGGLE_SPINNER = 'TOGGLE_SPINNER'

export function toggleSpinner(bool = false) {
  return {
    type: TOGGLE_SPINNER,
    payload: { isLoading: bool },
  }
}
